/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { DataTableHeader } from '../../../../data-table/DataTableHeader';
import { User } from '../../../../../models/User';
import { CustomItemContext } from 'app/components/data-table/data-table.component';

@Component({
  selector: 'app-ctv-traffic-overlap',
  templateUrl: './ctv-traffic-overlap.component.html',
  styleUrls: ['./ctv-traffic-overlap.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvTrafficOverlapComponent implements AfterViewInit, OnChanges {
  @Input() data;
  @Input() device: any;
  @Input() region: any;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;
  @Output() followClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('titleTemplate') titleTemplate: TemplateRef<CustomItemContext>;

  headers: Array<DataTableHeader>;
  byOverallMaxValueMapping: any;
  byIvtMaxValueMapping: any;
  byOverallStats: Array<any> = [];
  byIvtStats: Array<any> = [];
  hasAdSpendPermission: boolean;

  constructor(
    public _userService: User,
    private _changeDetector: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.headers = [];
    this.headers.push({
      class: 'col-3',
      text: 'App',
      key: 'title',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'Impression Overlap',
      key: 'impOverlapRate',
      tooltipkey: '',
      format: 'percentbar'
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'Device Overlap',
      key: 'deviceOverlapRate',
      tooltipkey: '',
      format: 'percentbar'
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'Developer',
      key: 'developerName',
      tooltipkey: ''
    });

    this.hasAdSpendPermission = this._userService.ctvAdSpendEnabled();

    this._changeDetector.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.byOverallMaxValueMapping = {};
      this.byIvtMaxValueMapping = {};
      if (this.isNotEmpty(this.data.overlapStats.byOverall)) {
        this.byOverallStats = [];
        this.byOverallMaxValueMapping['impOverlapRate'] = 0;
        this.byOverallMaxValueMapping['deviceOverlapRate'] = 0;
        this.data.overlapStats.byOverall.forEach(overlapStat => {
          const stat = JSON.parse(JSON.stringify(overlapStat));
          this.prepareOverlapStat(stat, this.byOverallMaxValueMapping);
          this.byOverallStats.push(stat);
        });
      }
      if (this.isNotEmpty(this.data.overlapStats.byIvt)) {
        this.byIvtStats = [];
        this.byIvtMaxValueMapping['impOverlapRate'] = 0;
        this.byIvtMaxValueMapping['deviceOverlapRate'] = 0;
        this.data.overlapStats.byIvt.forEach(overlapStat => {
          const stat = JSON.parse(JSON.stringify(overlapStat));
          this.prepareOverlapStat(stat, this.byIvtMaxValueMapping);
          this.byIvtStats.push(stat);
        });
      }
    }
  }

  follow(): void {
    this.followClick.emit(true);
  }

  isNotEmpty(arr: Array<any>) {
    return arr && arr.length > 0;
  }

  prepareOverlapStat(overlapStat: any, maxValueMapping: any) {
    overlapStat.titleRouterLink = [
      '/insight',
      'ctv',
      overlapStat.appId,
      this.region,
      this.device
    ];
    overlapStat.titleQueryParams = { section: '#app-overview' };
    overlapStat.titleTemplate = this.titleTemplate;

    if (maxValueMapping['impOverlapRate'] < overlapStat.impOverlapRate) {
      maxValueMapping['impOverlapRate'] = overlapStat.impOverlapRate;
    }
    if (maxValueMapping['deviceOverlapRate'] < overlapStat.deviceOverlapRate) {
      maxValueMapping['deviceOverlapRate'] = overlapStat.deviceOverlapRate;
    }
  }
}
